import ConsultingCaseListResourceModel from '../../generated/types/model/resource/ConsultingCaseListResourceModel';

export default class ConsultingCaseListResourceViewModel extends ConsultingCaseListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
